import { Component, input } from '@angular/core';

@Component({
  selector: 'pc-loading-spinner',
  standalone: true,
  template: `
    <div class="flex flex-col items-center justify-center py-12">
      <div class="spinner h-12 w-12"></div>
      @if (message()) {
        <p class="mt-4 text-muted">{{ message() }}</p>
      }
    </div>
  `,
})
export class LoadingSpinnerComponent {
  message = input<string>('Laden...');
}
